VjsAdmin.PlatformDistricts = (function () {
    const me = {};

    me.$table = $('#districts-table');

    me.init = function () {
        me.initTable();

        $('.app-content').on('click', '#export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = me.$table.bootstrapTable('getOptions').queryParams.call(me.$table.bootstrapTable('getOptions'));
            const visibleColumns = me.$table.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });
    };

    me.initTable = function () {
        const platformId = me.$table.attr('data-platform-id');
        me.$table.addClass('loading');

        me.$table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#districts-table',
            formatNoMatches() {
                return `No districts ${typeof this.searchText !== 'undefined' ? ` matching search term \`${this.searchText}\`` : ''}`;
            },
            toolbar: '#report-toolbar',
            toolbarAlign: 'left',
            sortName: 'district_id',
            sortOrder: 'desc',
            url: Slim.Router.pathFor('platforms.districts.list.json', {
                platform_id: platformId,
            }),
            columns,
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;
                $('.fixed-table-toolbar .search > input').val(me.search_term);

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    row.is_active = row.active;

                    // row.license_count = row.license_count+' License' +(row.license_count == 1 ?'':'s');
                    // row.user_count = row.user_count+' User' +(row.user_count == 1 ?'':'s');

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (row.district_joint_guid) {
                        if (VjsAdmin.hasPermission('platforms.districts.view')) {
                            const districtStatsUrl = Slim.Router.pathFor('platforms.districts.view', {
                                platform_id: platformId,
                                district_joint_guid: row.district_joint_guid,
                            });
                            row.name = `<a href="${districtStatsUrl}">${row.name}</a>`;
                        }

                        if (VjsAdmin.hasPermission('platforms.districts.licenses.list')) {
                            const licenseListUrl = Slim.Router.pathFor('platforms.districts.licenses.list', {
                                platform_id: platformId,
                                district_joint_guid: row.district_joint_guid,
                            });
                            row.license_count = `<a href="${licenseListUrl}">${row.license_count}</a>`;
                        }

                        if (VjsAdmin.hasPermission('platforms.districts.users.list')) {
                            const usersUrl = Slim.Router.pathFor('platforms.districts.users.list', {
                                platform_id: platformId,
                                district_joint_guid: row.district_joint_guid,
                            });
                            row.user_count = `<a href="${usersUrl}?search_roles=users">${row.user_count}</a>`;
                            row.admin_count = `<a href="${usersUrl}?search_roles=admins">${row.admin_count}</a>`;
                        }

                        if (VjsAdmin.hasPermission('platforms.districts.groups.list')) {
                            const groupsUrl = Slim.Router.pathFor('platforms.districts.groups.list', {
                                platform_id: platformId,
                                district_joint_guid: row.district_joint_guid,
                            });
                            row.group_count = `<a href="${groupsUrl}">${row.group_count}</a>`;
                        }

                        row.actions = '';
                        if (VjsAdmin.hasPermission('platforms.districts.edit.view')) {
                            const userUrl = Slim.Router.pathFor('districts.edit.view', { district_joint_guid: row.district_joint_guid });
                            row.actions += `<a href="${userUrl}" class="btn btn-hollow-blue">Edit</a>`;
                        }
                    }
                });
                return formattedResult;
            },
        });
    };

    const columns = [
        {
            title: 'ID',
            field: 'district_id',
            align: 'center',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Name',
            field: 'name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'State',
            field: 'state_code',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Licenses',
            field: 'license_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Users',
            field: 'user_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Admins',
            field: 'admin_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Groups',
            field: 'group_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: false,
        },
    ];

    return {
        init: me.init,
    };
}());
